import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { getViewModel, State } from '../state/unidad.selector';

@Component({
  selector: 'app-criterios',
  standalone: false,
  templateUrl: 'criterios.component.html',
  styleUrls: ['criterios.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,

  
})
export class CriteriosComponent {
  
  @Input() unidadMetaId: number;
  readonly vm$ = this.store.select(getViewModel);

  constructor(
    private store: Store<State>,
    private modalCriterio: MatDialog,
  ) { }


}
